import React, { useState, useCallback } from 'react';
import { Tabs } from 'antd';
import ImfCountryMappingTab from './ImfCountryMappingTab';
import ImfIndicatorMappingTab from './ImfIndicatorMappingTab';
import ImfConvertFetchTab from './ImfConvertFetchTab';

const { TabPane } = Tabs;

const ImfTabGroup = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const onConvertSuccess = useCallback(() => setRefreshKey(k => k + 1), []);

  return (
    <Tabs defaultActiveKey="comparison">
      <TabPane tab="Comparison" key="comparison">
        <ImfConvertFetchTab onConvertSuccess={onConvertSuccess} />
      </TabPane>
      <TabPane tab="Indicator Mapping" key="indicator">
        <ImfIndicatorMappingTab refreshTrigger={refreshKey} />
      </TabPane>
      <TabPane tab="Country Mapping" key="country">
        <ImfCountryMappingTab />
      </TabPane>
    </Tabs>
  );
};

export default ImfTabGroup;
